declare global {
	interface Window {
		google?: {
			maps?: unknown;
		};
	}
}

let googleMapsPromise: Promise<void> | null = null;

export function loadGoogleMaps(apiKey: string): Promise<void> {
	if (googleMapsPromise) {
		return googleMapsPromise;
	}

	googleMapsPromise = new Promise((resolve, reject) => {
		if (window.google?.maps) {
			resolve();
			return;
		}

		const script = document.createElement("script");
		script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
		script.async = true;
		script.defer = true;
		script.onload = () => resolve();
		script.onerror = () => reject(new Error("Failed to load Google Maps"));
		document.head.appendChild(script);
	});

	return googleMapsPromise;
}
